import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { useMedia } from 'pricing-pages-ui-components/hooks/useMedia';
import { Fragment, memo } from 'react';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { getLocalizedImages } from './getLocalizedImages';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FEATURES = {
  breezeIntelligence: 'breezeIntelligence',
  customerAgent: 'customerAgent',
  aiWorkflows: 'aiWorkflows',
  prospectingAgent: 'prospectingAgent',
  knowledgeBaseAgent: 'knowledgeBaseAgent',
  contentRemix: 'contentRemix',
  dataStudio: 'dataStudio',
  closingAgent: 'closingAgent'
};
const getKeyFeatures = tab => {
  const {
    breezeIntelligence,
    customerAgent,
    aiWorkflows,
    prospectingAgent,
    knowledgeBaseAgent,
    contentRemix,
    dataStudio,
    closingAgent
  } = FEATURES;
  switch (tab) {
    case NavItemEnum.SUITE:
      return [breezeIntelligence];
    case NavItemEnum.MARKETING:
      return [customerAgent, breezeIntelligence, aiWorkflows];
    case NavItemEnum.SALES:
      return [prospectingAgent, breezeIntelligence, aiWorkflows, customerAgent];
    case NavItemEnum.SERVICE:
      return [knowledgeBaseAgent, breezeIntelligence, aiWorkflows];
    case NavItemEnum.CONTENT:
      return [contentRemix, breezeIntelligence, customerAgent];
    case NavItemEnum.DATA:
      return [dataStudio, breezeIntelligence, aiWorkflows, customerAgent];
    case NavItemEnum.COMMERCE:
      return [contentRemix, breezeIntelligence, closingAgent];
    case NavItemEnum.MARKETING_PLUS:
      return [customerAgent, breezeIntelligence, aiWorkflows, contentRemix];
    default:
      return [];
  }
};
const GridRowLayout = ({
  reverse,
  description,
  image
}) => {
  const currentOrder = reverse ? [description, image] : [image, description];
  return /*#__PURE__*/_jsx(Fragment, {
    children: currentOrder.map((item, index) => {
      return /*#__PURE__*/_jsx(PPUIGridItem, {
        children: item
      }, `item-${index}`);
    })
  });
};
const HubSpotCreditsFeatures = ({
  subscreen
}) => {
  const isMaxWidthTablet = useMedia('tablet');
  const features = Array.isArray(subscreen) ? [...new Set(subscreen.flatMap(getKeyFeatures))] : getKeyFeatures(subscreen);
  if (!features) return null;
  return /*#__PURE__*/_jsx(PPUIGrid, {
    gridTemplateColumns: isMaxWidthTablet ? '1fr' : '1fr 1fr',
    rowGap: isMaxWidthTablet ? '1400' : '1500',
    alignItems: "center",
    justifyItems: "center",
    children: features.map((feature, index) => {
      return /*#__PURE__*/_jsx(GridRowLayout, {
        reverse: !isMaxWidthTablet && index % 2 === 1,
        image: /*#__PURE__*/_jsx(Image, {
          src: getLocalizedImages(feature)
        }),
        description: /*#__PURE__*/_jsxs(View, {
          marginInlineStart: index % 2 === 0 ? '800' : '0',
          marginInlineEnd: index % 2 === 0 ? '0' : '800',
          marginInline: isMaxWidthTablet ? '0 !important' : undefined,
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h3",
            typography: "heading-500",
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `pricingPage.pages.hubspot-credits.keyFeatures.features.${feature}.title`
            })
          }), /*#__PURE__*/_jsx(List, {
            styled: true,
            children: new Array(3).fill(null).map((_, i) => {
              const descriptionKey = `pricingPage.pages.hubspot-credits.keyFeatures.features.${feature}.description.${i + 1}`;
              return isValidI18nKey(descriptionKey) ? /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: descriptionKey
                })
              }, `${feature}-description-${i}`) : null;
            })
          })]
        })
      }, `row-${index}`);
    })
  });
};
export default /*#__PURE__*/memo(HubSpotCreditsFeatures);